exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#language-switcher .dropdown-toggle{padding:0}#language-switcher .dropdown-menu{min-width:4rem}#language-switcher .badge{padding:10.5px;font-size:14px}", ""]);

// exports
